import {
  BulkUpdateExpectedVolumesInput,
  BulkUpdateExpectedVolumesMutation,
  BulkUpdateExpectedVolumesMutationVariables,
} from "@/gql/graphql";
import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";

const mutation = gql`
  mutation BulkUpdateExpectedVolumes($input: BulkUpdateExpectedVolumesInput!) {
    productPrice {
      expectedVolume {
        bulkUpdateExpectedVolumes(input: $input) {
          __typename
          ... on ErrorResult {
            errors {
              message
              path
            }
          }
          ... on BulkUpdateExpectedVolumesSuccessResult {
            success
          }
        }
      }
    }
  }
`;

export const useBulkUpdateExpectedVolumesMutation = () => {
  const [mutate, { loading }] = useMutation<
    BulkUpdateExpectedVolumesMutation,
    BulkUpdateExpectedVolumesMutationVariables
  >(mutation);
  const bulkUpdateExpectedVolumes = useCallback(
    (input: BulkUpdateExpectedVolumesInput) => {
      return mutate({
        variables: {
          input,
        },
      });
    },
    [mutate]
  );
  return {
    bulkUpdateExpectedVolumes,
    loading,
  };
};
